
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.275 15.853l-2.654 2.44a12.694 12.694 0 01-4.703 2.594l.704 3.285a1.094 1.094 0 001.608.724l4.273-2.41a3.321 3.321 0 001.504-3.614l-.732-3.019zM6.82 9.457l2.285-2.714-2.85-.687A3.039 3.039 0 002.55 7.54L.14 11.808a1.094 1.094 0 00.724 1.607l3.362.721c.558-1.71 1.437-3.3 2.592-4.68zm10.36.044a1.641 1.641 0 100-3.283 1.641 1.641 0 000 3.283z","fill":"#40916C"}}),_c('path',{attrs:{"d":"M23.598 2.11a1.095 1.095 0 00-.78-.78 12.308 12.308 0 00-12.494 3.965L6.819 9.457a14.154 14.154 0 00-3.2 7.342 1.094 1.094 0 00.312.916l3.392 3.391a1.094 1.094 0 00.869.317 12.963 12.963 0 007.429-3.13l4.008-3.685a12.259 12.259 0 003.969-12.497zm-6.42 7.39a1.641 1.641 0 110-3.282 1.641 1.641 0 010 3.283z","fill":"#52B788"}})])
          )
        }
      }
    